import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Text filled with a light-blue base whose white highlight sweeps across the
// glyphs from left to right on a loop. The gradient is painted twice as wide
// as the element and tiled, so sliding background-position from 100% to -100%
// carries the highlight band across once per cycle, and the next tile's band
// arrives at the left edge exactly as the cycle restarts — no visible jump.
export default function ShinyText({
  text,
  speed = 3,
  baseColor = "#64CEFB",
  shineColor = "#ffffff",
  spread = 100,
  className = "",
}) {
  const reduced = useReducedMotion();

  if (reduced) {
    return (
      <span className={className} style={{ color: baseColor }}>
        {text}
      </span>
    );
  }

  return (
    <motion.span
      className={className}
      style={{
        backgroundImage: `linear-gradient(${spread}deg, ${baseColor} 40%, ${shineColor} 50%, ${baseColor} 60%)`,
        backgroundSize: "200% 100%",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        WebkitTextFillColor: "transparent",
        color: "transparent",
      }}
      initial={{ backgroundPosition: "100% 50%" }}
      animate={{ backgroundPosition: "-100% 50%" }}
      transition={{ duration: speed, ease: "linear", repeat: Infinity }}
    >
      {text}
    </motion.span>
  );
}
